import { formatCurrency } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { OrganizationsService } from 'src/app/Services/organizations.service';

@Component({
    selector: 'app-currency-input',
    templateUrl: './currency-input.component.html',
    styleUrls: ['./currency-input.component.scss'],
    standalone: false
})
export class CurrencyInputComponent implements OnInit, ControlValueAccessor {

  public DisplayValue : string = "";
  private DecimalSeparator : string = ".";
  @Input()
  public Disabled : boolean = false;

  // When true, allow the user to enter negative currency values (e.g. -10.00).
  // Defaults to false so existing usages remain non-negative unless explicitly enabled.
  @Input()
  public AllowNegative: boolean = false;

  private _internalValue: number | null = 0;

  @Input()
  set InternalValue(value: number | null) {
    this._internalValue = value;
    this.UpdateDisplayedValue();
  }

  get InternalValue(): number | null {
    return this._internalValue;
  }
  
  @Input() 
  public MaxValue: number | null = 0;

  @Output() ValueChanged = new EventEmitter();


  constructor(private organizationsService : OrganizationsService,  private injector: Injector) { 
    const ngControl: NgControl | null = this.injector.get(NgControl, null);
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
    //find the char used by this locale as a decimal separator for later parsing
    let separatorString = 1.1;
    this.DecimalSeparator = separatorString.toLocaleString().substring(1, 2);
  }

  ngOnInit(): void {
      this.UpdateDisplayedValue();
  }

  public writeValue(val : number | null): void {
    this.InternalValue = val;
    this.UpdateDisplayedValue();
  }

  public onChange = (val : number | null) => {};
  public registerOnChange(fn: any): void {
      this.onChange = fn;
  }
  public onTouched = () => {};
  public registerOnTouched(fn: any): void {
      this.onTouched = fn;
  }

  public InputEntered(){
    if(this.InternalValue != null){
      this.DisplayValue = this.InternalValue.toString();
    }
  }

  public InputBlurred(){
   this.UpdatedByUser();
   this.onChange(this.InternalValue);
   this.ValueChanged.emit(this.InternalValue);
  }

  public UpdatedByUser(){
    if(this.DisplayValue != ""){
      // Extract numeric value from the input, preserving a leading minus sign.
      // Strip everything except digits, comma, dot and minus, then normalise to '.' as decimal.
      let cleaned = this.DisplayValue.replace(/[^-0-9\.,]/g, '');
      cleaned = cleaned.replace(/,/g, '.');

      let val = parseFloat(cleaned);
      if (!isNaN(val)) {
        this.InternalValue = val;

        if(this.MaxValue && (this.InternalValue > this.MaxValue)){
          this.InternalValue = this.MaxValue;
        }

        this.UpdateDisplayedValue();
        return;
      }
    }
    this.InternalValue = null;
   this.DisplayValue = "";
  }

  public UpdateDisplayedValue(){
    if(this.InternalValue != null){
      var currency = this.organizationsService.GetCurrencySymbol();
      this.DisplayValue = formatCurrency(this.InternalValue, this.organizationsService.GetLocale(), currency, '', '1.2-4');
    }
    else
      this.DisplayValue = "";
  }


}
